import React from 'react';
import { useTable, useSortBy, usePagination, useGlobalFilter } from 'react-table';

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize, globalFilter },
    gotoPage,
    pageOptions,
    setPageSize,
    setGlobalFilter,
  } = useTable(
    { columns, data, initialState: { pageSize: 10 } },
    useGlobalFilter, // Add useGlobalFilter
    useSortBy,
    usePagination
  );

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        {/* <label>Search: </label> */}
        <input
          type="text"
          value={globalFilter || ''}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder='Search Student'
          style={{ borderRadius: "5px", padding: "5px" }}
        />
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table {...getTableProps()} style={{ border: '1px solid black', width: '100%' }}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{ border: '1px solid #FFF', background: '#223046', textAlign: 'center', color: "#fff", padding: "5px 10px", whiteSpace: 'nowrap' }}
                  >
                    {column.render('Header')}
                    {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map(cell => (
                    <td
                      {...cell.getCellProps()}
                      style={{ border: '1px solid black', padding: '8px', textAlign: 'center', whiteSpace: 'nowrap' }}
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
          <span>
            | Go to page:{' '}
            <input
              type="number"
              value={pageIndex + 1}
              onChange={e => {
                const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(pageNumber);
              }}
              style={{ width: '50px' }}
            />
          </span>
        </div>
        <div>
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value));
            }}
            style={{ padding: "5px 10px" }}
          >
            {[10, 20, 50, data.length].map(pageSizeOption => (
              <option key={pageSizeOption} value={pageSizeOption}>
                {pageSizeOption === data.length ? 'Show All' : `Show ${pageSizeOption}`}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

const PaginatedSortedTable = (props) => {
  const generateColumns = (data) => {
    const columns = [
      { Header: 'Student', accessor: 'student_name' },
      { Header: 'Roll No', accessor: 'roll_no' },
      { Header: 'Branch', accessor: 'branch_name', disableSortBy: true },
      { Header: "Section", accessor: "section_name", disableSortBy: true }
    ];

    Object.keys(data[0]).forEach(key => {
      if (key !== 'student_name' && key !== 'branch_name' && key !== 'section_name') {
        let subjects = [];
        Object.keys(data[0][key]).forEach(key1 => {
          subjects.push({
            Header: key1.replace("_", " ").toString(),
            accessor: `${key}.${key1}`,
          })
        })

        columns.push({
          Header: key.toString(),
          accessor: key.toString(),
          disableSortBy: true,
          columns: subjects
        });
      }
    });
    return columns;
  };



  const dynamicColumns = generateColumns(props.getOffExamResults);

  console.log("geddd", dynamicColumns);

  return <Table columns={dynamicColumns} data={props.getOffExamResults} />;
};

export default PaginatedSortedTable;
